const actions = {
  REQUESTING: 'Invoice2s/REQUESTING',
  RESPONSE_ERROR: 'Invoice2s/RESPONSE_ERROR',

  FETCH_WORKORDERS_FILTER_FOR_EXISTING_INVOICE2:
    'Invoice2WorkOrder/FETCH_FILTER_FOR_EXISTING_INVOICE2',
  LIST_WORKORDER_FOR_EXISTING_INVOICE2: 'Invoice2WorkOrder/LIST_FOR_EXISTING_INVOICE2',

  DELETE_WORKORDERS_FROM_INVOICE2: 'Invoice2WorkOrder/DELETE_FROM_INVOICE2',
  DELETE_WORKORDERS_FROM_INVOICE2_RECIEVED: 'Invoice2WorkOrder/DELETE_FROM_INVOICE2_RECIEVED',
}

export default actions
